import React, { useEffect, useState } from 'react';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
import { contactInfo } from '../mockData';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    school: '',
    serviceType: 'Okul Servisi',
    message: ''
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create WhatsApp message
    const whatsappMessage = `Merhaba,\n\nAd Soyad: ${formData.name}\nTelefon: ${formData.phone}\nOkul Adı: ${formData.school}\nHizmet Türü: ${formData.serviceType}\nMesaj: ${formData.message}\n\nBilgi almak istiyorum.`;
    
    // Encode message for URL
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    // WhatsApp number (formatted)
    const whatsappNumber = contactInfo.whatsappFormatted;
    
    // Redirect to WhatsApp
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="page-contact">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">İletişim</h1>
          <p className="page-subtitle">
            Size yardımcı olmaktan mutluluk duyarız
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info">
              <h2 className="contact-heading">İletişim Bilgileri</h2>
              <p className="contact-desc">
                Bizimle iletişime geçmek için aşağıdaki bilgileri kullanabilir 
                veya formu doldurarak WhatsApp üzerinden hızlıca mesaj gönderebilirsiniz.
              </p>

              <div className="contact-items">
                <a href={`tel:${contactInfo.phone}`} className="contact-item">
                  <div className="contact-icon">
                    <Phone size={24} />
                  </div>
                  <div className="contact-detail">
                    <h4>Telefon 1</h4>
                    <p>{contactInfo.phone}</p>
                  </div>
                </a>

                <a href={`tel:${contactInfo.phone3}`} className="contact-item">
                  <div className="contact-icon">
                    <Phone size={24} />
                  </div>
                  <div className="contact-detail">
                    <h4>Telefon 2</h4>
                    <p>{contactInfo.phone3}</p>
                  </div>
                </a>

                <a href={`https://wa.me/${contactInfo.whatsappFormatted}`} className="contact-item">
                  <div className="contact-icon whatsapp">
                    <Phone size={24} />
                  </div>
                  <div className="contact-detail">
                    <h4>WhatsApp</h4>
                    <p>{contactInfo.whatsapp}</p>
                  </div>
                </a>

                <a href={`mailto:${contactInfo.email}`} className="contact-item">
                  <div className="contact-icon">
                    <Mail size={24} />
                  </div>
                  <div className="contact-detail">
                    <h4>E-posta</h4>
                    <p>{contactInfo.email}</p>
                  </div>
                </a>

                <div className="contact-item">
                  <div className="contact-icon">
                    <MapPin size={24} />
                  </div>
                  <div className="contact-detail">
                    <h4>Adres</h4>
                    <p>{contactInfo.address}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <h2 className="contact-heading">Mesaj Gönderin</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Ad Soyad *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Telefon *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="school">Okul Adı</label>
                  <input
                    type="text"
                    id="school"
                    name="school"
                    value={formData.school}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="serviceType">Hizmet Türü *</label>
                  <select
                    id="serviceType"
                    name="serviceType"
                    value={formData.serviceType}
                    onChange={handleChange}
                    required
                  >
                    <option value="Okul Servisi">Okul Servisi</option>
                    <option value="Öğrenci Taşımacılığı">Öğrenci Taşımacılığı</option>
                    <option value="Personel Taşımacılığı">Personel Taşımacılığı</option>
                    <option value="Araç Filosu">Araç Filosu Bilgisi</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mesajınız *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-full">
                  <Send size={20} />
                  WhatsApp ile Gönder
                </button>

                <p className="form-note">
                  * Formu göndererek WhatsApp üzerinden mesajınız iletilecektir
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <iframe
          src={contactInfo.mapUrl}
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Vizyon Turizm Konum"
        ></iframe>
      </section>
    </div>
  );
};

export default Contact;
